<div class="utilContainer mat-elevation-z8" id="utilContainer" cdkDropList (cdkDropListDropped)="drop($event)">
	@for (tmpl of templates; track tmpl; let i = $index) {
		<div
			class="paneContainer"
			[class.removed]="panels[i].undocked"
			cdkDrag
			[cdkDragDisabled]="!draggable"
			[id]="'paneContainer' + i"
			[class.open]="panels[i].open && !panels[i].undocked"
		>
			<div class="pane" [class.open]="panels[i].open" [class.active]="panelOptions.activePanel === i">
				<div class="header" cdkDragHandle (click)="openPanel(i)">
					<div class="icon">
						<mat-icon [fontSet]="panels[i].fontset" [fontIcon]="panels[i].icon" inline />
					</div>
					<div class="text">
						<span class="nomargin">{{ panels[i].title | translate }}</span>
					</div>
					@if (showControls) {
						<div class="controls">
							<mat-menu #appMenu="matMenu">
								<button mat-menu-item (click)="undockPane(i)">
									<mat-icon fontSet="far" fontIcon="fa-window-restore" inline />
									<span>{{ T.SHARED_NEW_PANEL_UNDOCK | translate }}</span>
								</button>
								<button mat-menu-item>
									<mat-icon fontSet="fas" fontIcon="fa-eye" inline />
									<span>{{ T.SHARED_NEW_PANEL_HIDE | translate }}</span>
								</button>
								<button mat-menu-item>
									<mat-icon fontSet="fas" fontIcon="fa-check-circle" inline />
									<span>{{ T.SHARED_NEW_PANEL_DEFAULT_OPEN | translate }}</span>
								</button>
							</mat-menu>
							@if (editMenue) {
								<button
									appStopPropagation
									mat-icon-button
									[matMenuTriggerFor]="appMenu"
									matTooltipClass="primary"
									matTooltip="{{ T.SHARED_NEW_PANEL_OPEN_MENU | translate }}"
								>
									<mat-icon fontSet="far" fontIcon="fa-ellipsis-v" inline />
								</button>
							}
							@if (openable) {
								<button
									mat-icon-button
									id="toggleExpand"
									matTooltipClass="primary"
									matTooltip="{{ T.SHARED_NEW_PANEL_EXPAND_COLLAPSE_PANE | translate }}"
								>
									<mat-icon fontSet="far" fontIcon="fa-chevron-down" inline />
								</button>
							}
							<ng-container [ngTemplateOutlet]="templatesHeader._results[i]" />
						</div>
					}
				</div>
				<div class="content">
					@if (panels[i].open) {
						<ng-container [ngTemplateOutlet]="tmpl" />
					}
				</div>
			</div>
		</div>
	}
</div>
